import { ROUTES } from '@/app/router/routes';
import { BriefcaseIcon, CalendarIcon, TimesheetIcon } from '@/components/icons';

export const NAV_ITEMS = [
  { to: '/factures', label: 'Mes factures', icon: BriefcaseIcon },
  { to: ROUTES.timesheets, label: 'Mes CRA', icon: TimesheetIcon },
  { to: ROUTES.leaves, label: 'Mes congés', icon: CalendarIcon },
  { to: ROUTES.missions, label: 'Mes missions', icon: BriefcaseIcon },
];

export const isModuleActive = (pathname: string, to: string) =>
  pathname === to || pathname.startsWith(`${to}/`);
